import { render } from "./resources.vue?vue&type=template&id=6230f27e"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"
script.render = render

export default script